const lang = navigator.language;
const accouncements = document.getElementsByClassName('announcement-bar');
for (let i = 0; i < accouncements.length; i++) {
  let accouncement_child =  accouncements[i].firstChild;
  if (lang == 'ja' || lang == 'ja-JP') {
    if (accouncement_child.href != 'https://yukimono.jp/') {
      accouncement_child.parentNode.remove()
    }
  } else {
    if (accouncement_child.href == 'https://yukimono.jp/') {
      accouncement_child.parentNode.remove()
    }
  }
}
